/**
 * The two-sided compare toggle for a live review — which version of the slide
 * is on the canvas right now. Same interaction as the chat card's
 * Original/Proposed pills; labels adapt to the review kind (proposal, revert,
 * re-apply). `showing` is 'candidate' (the change under review) or 'current'.
 */
import type { MouseEventHandler } from 'react';
import type { FlipShowing } from '../lib/reviewFlip.ts';

type FlipPillsProps = {
  showing: FlipShowing;
  currentLabel: string;
  candidateLabel: string;
  /** Goes straight onto the button's `onClick`, so it receives the event —
   *  the Activity row's handlers rely on that to stopPropagation before the
   *  row's own jump fires. */
  onToggle: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
};

export default function FlipPills({ showing, currentLabel, candidateLabel, onToggle, disabled }: FlipPillsProps) {
  return (
    <button
      type="button"
      className="flip-pills"
      onClick={onToggle}
      disabled={disabled}
      title="Preview only: flip between the two versions to compare. It doesn't change your slide; the buttons decide that."
    >
      <span className={'flip-pills__pill' + (showing === 'current' ? ' flip-pills__pill--active' : '')}>
        {currentLabel}
      </span>
      <span className={'flip-pills__pill' + (showing === 'candidate' ? ' flip-pills__pill--active' : '')}>
        {candidateLabel}
      </span>
    </button>
  );
}
